<template>
	<div class="tabWrapperSettings tabDocumentsTypes">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="documentsTypesDocumentsTypes"
				@updateClickButton="onClickButton($event, flag)"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateCreate="onCreate"
				text-create="Add new document type"
				page-title="Documents Types"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-documents-types
				v-if="isViewDocumentsTypes"
				:dialogFlag="dialogFlag"
				:editDocumentsTypes="editDocumentsTypes"
				@updateSave="onSaveViewDocumentsTypes"
				@updateClose="onCloseDialog('isViewDocumentsTypes')"
				@updateList="onUpdateList('documentsTypes')"
		></view-documents-types>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabDocumentsTypesTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewDocumentsTypes from "@/components/Settings/UserAccountSettings/ViewDocumentsTypes/ViewDocumentsTypes.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

import { mapActions, mapGetters } from "vuex";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabDocumentsTypes",
	components: {
		DialogRemove,
		ViewDocumentsTypes,
		MainTable
	},
	computed: {
		...mapGetters([
			'editDocumentsTypes',
			'settingsDocumentsTypes',
			'documentsTypesDocumentsTypes',
			'filtersDocumentsTypes',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabDocumentsTypesTable;
		},
	},

	data: () => ({
		flag: TAB.DOCUMENTS_TYPES,

		isViewDocumentsTypes: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountDocumentsTypesList',
			'getAccountDocumentsTypesEdit',
			'deleteAccountDocumentsTypes',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_DOCUMENTS, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},

		async onUpdateList(key) {
			if (key === 'documentsTypes') {
				await this.getAccountDocumentsTypesList();
			}
		},

		onClickButton({ key, item }, nameComponent) {
			this.dialogFlag = 'edit';
			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === 'tabDocumentsTypes' && key === 'edit1') {
				this.accountDocumentsTypesEdit();
			}
			if (nameComponent === 'tabDocumentsTypes' && key === 'delete1') {
				const title = TITLE.REMOVE_DOCUMENTS_TYPES;
				const text = TEXT.REMOVE_DOCUMENTS_TYPES;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'tabDocumentsTypes') {
				const { id } = this.activeItem;
				await this.deleteAccountDocumentsTypes(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountDocumentsTypesEdit() {
			const { id } = this.activeItem;
			await this.getAccountDocumentsTypesEdit(id);
			this.isViewDocumentsTypes = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewDocumentsTypes = true;
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountDocumentsTypesList();
	}
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
</style>

